import { useEffect, useState, useCallback } from 'react';

const useKeyboardShortcuts = ({
  onNewTask,
  onSearch,
  onToggleView,
  onEscape,
  onDelete,
  onSelectAll,
}) => {
  const [showHelp, setShowHelp] = useState(false);

  const handleKeyDown = useCallback((e) => {
    // Don't trigger shortcuts when typing in inputs
    const tag = e.target.tagName;
    const isInput = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target.isContentEditable;

    // Escape always works
    if (e.key === 'Escape') {
      if (showHelp) { setShowHelp(false); return; }
      onEscape?.();
      return;
    }

    // These shortcuts only work outside of inputs
    if (isInput) return;

    // ? or Ctrl+/ = Show shortcuts help
    if (e.key === '?' || (e.ctrlKey && e.key === '/')) {
      e.preventDefault();
      setShowHelp(v => !v);
      return;
    }

    // n = New task
    if (e.key === 'n' && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      onNewTask?.();
      return;
    }

    // / or Ctrl+K = Search
    if (e.key === '/' || (e.ctrlKey && e.key === 'k')) {
      e.preventDefault();
      onSearch?.();
      return;
    }

    // 1-5 = Switch views
    if (['1', '2', '3', '4', '5'].includes(e.key) && !e.ctrlKey && !e.metaKey) {
      const views = ['lista', 'tablero', 'gantt', 'calendario', 'panel'];
      onToggleView?.(views[parseInt(e.key) - 1]);
      return;
    }

    // Ctrl+A = Select all
    if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
      e.preventDefault();
      onSelectAll?.();
      return;
    }

    // Delete or Backspace = Delete selected
    if (e.key === 'Delete' || e.key === 'Backspace') {
      onDelete?.();
      return;
    }
  }, [onNewTask, onSearch, onToggleView, onEscape, onDelete, onSelectAll, showHelp]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return { showHelp, setShowHelp };
};

export const SHORTCUTS = [
  { keys: ['N'], description: 'Nueva tarea' },
  { keys: ['/', 'Ctrl+K'], description: 'Buscar' },
  { keys: ['1-5'], description: 'Cambiar vista (Lista, Tablero, Gantt, Calendario, Panel)' },
  { keys: ['Ctrl+A'], description: 'Seleccionar todas las tareas' },
  { keys: ['Delete'], description: 'Eliminar seleccionadas' },
  { keys: ['Esc'], description: 'Cerrar panel / Deseleccionar' },
  { keys: ['?', 'Ctrl+/'], description: 'Mostrar atajos' },
];

export default useKeyboardShortcuts;
